/* HOLT — centred search modal.
   - intercepts the theme's search icon and opens our panel instead
   - live results from Shopify's /search/suggest.json
   - "recently viewed" kept in localStorage, written on each product page

   Everything is delegated from document so it survives section re-renders
   in the theme editor. */
(function () {
  var KEY = 'holt:recent';
  var MAX_STORED = 12;
  var root, input, body, recentWrap, recentGrid, resultsGrid, resultsLabel,
      emptyMsg, viewAll, defaultGridHTML, defaultLabel;
  var timer = null, controller = null, lastFocus = null;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- recently viewed ---------- */
  function readRecent() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function recordView() {
    var tag = document.querySelector('[data-holt-viewed]');
    if (!tag) return;
    var item;
    try { item = JSON.parse(tag.textContent); } catch (e) { return; }
    if (!item || !item.handle) return;

    var list = readRecent().filter(function (p) { return p.handle !== item.handle; });
    list.unshift(item);
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch (e) {}
  }

  function cardHTML(p) {
    var img = p.image
      ? '<img src="' + p.image + '" alt="" loading="lazy" width="200" height="200">'
      : '';
    return '<a class="holt-search__card" href="' + p.url + '">' +
             '<span class="holt-search__thumb">' + img + '</span>' +
             '<span class="holt-search__name">' + escapeHTML(p.title) + '</span>' +
             '<span class="holt-search__price">' + (p.price || '') + '</span>' +
           '</a>';
  }

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function paintRecent() {
    if (!recentWrap) return;
    var max = parseInt(root.dataset.recentMax, 10) || 4;
    var list = readRecent().slice(0, max);
    if (!list.length) { recentWrap.hidden = true; return; }
    recentGrid.innerHTML = list.map(cardHTML).join('');
    recentWrap.hidden = false;
  }

  /* ---------- open / close ---------- */
  function open(e) {
    if (e) e.preventDefault();
    if (!root || !root.hidden === false && root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    paintRecent();
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      setTimeout(function () { input && input.focus(); }, 60);
    });
  }

  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      root.hidden = true;
      reset();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }, 220);
  }

  function reset() {
    if (input) input.value = '';
    if (resultsGrid && defaultGridHTML != null) resultsGrid.innerHTML = defaultGridHTML;
    if (resultsLabel && defaultLabel != null) resultsLabel.textContent = defaultLabel;
    if (emptyMsg) emptyMsg.hidden = true;
    if (viewAll) viewAll.hidden = true;
    root.classList.remove('is-busy');
  }

  /* ---------- live search ---------- */
  function search(q) {
    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;

    var url = rootUrl() + 'search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8' +
              '&resources[options][unavailable_products]=last';

    root.classList.add('is-busy');

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        root.classList.remove('is-busy');

        resultsLabel.textContent = items.length
          ? (resultsLabel.dataset.foundLabel || defaultLabel)
          : (resultsLabel.dataset.foundLabel || defaultLabel);

        if (!items.length) {
          resultsGrid.innerHTML = '';
          emptyMsg.hidden = false;
          if (viewAll) viewAll.hidden = true;
          return;
        }

        emptyMsg.hidden = true;
        resultsGrid.innerHTML = items.map(function (p) {
          return cardHTML({
            url: p.url,
            title: p.title,
            image: p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || ''),
            price: p.price ? formatMoney(p.price) : ''
          });
        }).join('');

        if (viewAll) {
          viewAll.hidden = false;
          viewAll.href = rootUrl() + 'search?q=' + encodeURIComponent(q);
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        root.classList.remove('is-busy');
      });
  }

  /* suggest.json returns price as a formatted string on some themes and raw
     cents on others. When it's a number, format it with the shop's own
     money_format (injected from Liquid) rather than assuming a currency. */
  function formatMoney(v) {
    if (v == null || v === '') return '';
    if (typeof v === 'string' && v.trim() && !/^[\d.,]+$/.test(v.trim())) return v;

    var cents = Number(String(v).replace(/[^\d.-]/g, ''));
    if (isNaN(cents)) return '';
    /* a bare "50.00" has already been divided; cents are always integers */
    if (String(v).indexOf('.') > -1) cents = Math.round(cents * 100);

    var fmt = (root && root.dataset.moneyFormat) || '£{{amount}}';

    function withDelims(num, decimals, thousands, decimal) {
      var n = (num / 100).toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts.join(decimal) : parts[0];
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, token) {
      switch (token) {
        case 'amount':                            return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals':                return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator':       return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':  return withDelims(cents, 2, "'", '.');
        default:                                  return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- wiring ---------- */
  function init() {
    root = document.getElementById('holt-search');
    if (!root || root.dataset.holtBound === '1') return;
    root.dataset.holtBound = '1';

    input        = root.querySelector('[data-hs-input]');
    body         = root.querySelector('[data-hs-body]');
    recentWrap   = root.querySelector('[data-hs-recent]');
    recentGrid   = root.querySelector('[data-hs-recent-grid]');
    resultsGrid  = root.querySelector('[data-hs-results-grid]');
    resultsLabel = root.querySelector('[data-hs-results-label]');
    emptyMsg     = root.querySelector('[data-hs-empty]');
    viewAll      = root.querySelector('[data-hs-all]');

    defaultGridHTML = resultsGrid ? resultsGrid.innerHTML : '';
    defaultLabel    = resultsLabel ? resultsLabel.textContent.trim() : '';

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        if (controller) controller.abort();
        root.classList.remove('is-busy');
        resultsGrid.innerHTML = defaultGridHTML;
        resultsLabel.textContent = defaultLabel;
        emptyMsg.hidden = true;
        if (viewAll) viewAll.hidden = true;
        return;
      }
      timer = setTimeout(function () { search(q); }, 220);
    });

    /* keep the form submit working — enter goes to the full results page */
    root.querySelector('.holt-search__bar').addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });
  }

  /* the theme's own search icon opens ours instead.
     Capture phase + stopImmediatePropagation, so the theme's <header-search>
     listener never runs and its overlay never opens alongside ours. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest &&
      e.target.closest('.header__icon--search, [data-holt-search-open]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      init();
      open(e);
      return;
    }

    if (e.target.closest && e.target.closest('[data-hs-close]')) { close(); return; }

    if (e.target.closest && e.target.closest('[data-hs-clear]')) {
      try { localStorage.removeItem(KEY); } catch (err) {}
      paintRecent();
      return;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root && !root.hidden) close();
    /* cmd/ctrl + K opens it, like most storefronts now do */
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault(); init(); open();
    }
  });

  function boot() { init(); recordView(); }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function () {
    if (root) root.dataset.holtBound = '';
    init();
  });
  if (document.readyState !== 'loading') boot();
})();
